<template>
  <div class="model_client_order">
    <div class="model_client_order__header">
      <h4 class="title">
        {{ translate("client_order.formation_orders") }}
      </h4>
    </div>

    <div class="model_client_order__body">
      <div class="client_order">

        <div class="row">
          <div class="input_wrap">
            <label>
              {{ translate('client_order.actions') }}
            </label>
            <tree-select
                :options="action_list"
                :placeholder="translate('client_order.actions')"
                v-model="primary_data.type"
                :clearable="false"
                :multiple="false"
            />
          </div>
        </div>

      </div>
    </div>
    <div class="model_client_order__footer">
<!--      <span-->
<!--          :disabled="check_count"-->
<!--          class="btn btn-success btn-fill btn-wd"-->
<!--          @click.prevent="create_client_order"-->
<!--      >-->
<!--        {{ translate('btn.create') }}-->
<!--      </span>-->
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>

export default {
  name: 'FormationOrder',
  components: {},
  data () {
    return {
      primary_data: {
        action: null
      },
    }
  },
  computed:{
    action_list(){
      return [
        {id: 1, label: "Формирование посылки"},
        {id: 2, label: "Формирование акта приема - передачи"},
        {id: 3, label: "Формирование УПД"},
      ]
    },
  },

  methods: {
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_client_order{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      height: 600px;
      .client_order{
        width: 100%;
        height: 100%;
        .block{
          height: calc(100% - 35px);
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
          overflow-y: auto;
          .line{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .input_wrap{
              width: 100%;
              text-align: start;
              margin-bottom: 10px;
              display: flex;
              flex-direction: column;
              margin-right: 10px;
              &:last-child{
                margin-right: 0;
              }
              .form-control{

                width: 100%;
              }
            }
          }

          &::-webkit-scrollbar{
            width: 10px;
          }
        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
